var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.8489 7.50084",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6644 1.06754L7.3698 7.31754C7.31134 7.37565 7.24192 7.42175 7.1655 7.4532C7.08909 7.48465 7.00718 7.50084 6.92446 7.50084C6.84174 7.50084 6.75983 7.48465 6.68341 7.4532C6.60699 7.42175 6.53757 7.37565 6.47911 7.31754L0.184468 1.06754C0.0663552 0.95026 0 0.7912 0 0.625347C0 0.459495 0.0663552 0.300435 0.184468 0.18316C0.302581 0.0658843 0.462777 0 0.629814 0C0.796851 0 0.957047 0.0658843 1.07516 0.18316L6.92446 5.99175L12.7738 0.18316C12.8322 0.125091 12.9017 0.0790281 12.9781 0.0476015C13.0545 0.0161748 13.1364 0 13.2191 0C13.3018 0 13.3837 0.0161748 13.4601 0.0476015C13.5365 0.0790281 13.606 0.125091 13.6644 0.18316C13.7229 0.241229 13.7693 0.310167 13.801 0.386037C13.8326 0.461908 13.8489 0.543226 13.8489 0.625347C13.8489 0.707469 13.8326 0.788787 13.801 0.864658C13.7693 0.940528 13.7229 1.00947 13.6644 1.06754Z",
    fill: "var(--fill-0, black)",
    transform: "rotate(180 6.92445 3.75042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.629db773cd9d6b3fc5d934cc35b5f7e7.svg";
export { ForwardRef as ReactComponent };